import { getDemographics } from 'demographics-client';
import { getEarlyRequestByKey } from 'setup-guide-api/utils/earlyRequestUtils';
import { captureNetworkError } from 'growth-onboarding-reliability/utils/raven';
import { QUICK_FETCH_DEMOGRAPHICS_KEY } from '../constants/taskConstants';
export function fetchDemographics() {
  return getEarlyRequestByKey(QUICK_FETCH_DEMOGRAPHICS_KEY, getDemographics).catch(error => {
    captureNetworkError(error);
    return {};
  });
}